import { useParams } from "next/navigation";

import { useTeamChats } from "@/store/useTeamChats";

/**
 * The chats list options for `useVisibleRowsCounts`: a hidden or collapsed
 * section takes no rows and the current chat always stays within the visible
 * range.
 */
export function useChatRowsOptions() {
  const teamChats = useTeamChats();
  const { chatId } = useParams<{ [key: string]: string | undefined }>();

  const areRowsShown = teamChats.isAvailable && teamChats.isSectionOpen;

  return {
    totalCount: areRowsShown ? teamChats.collectiveChatsCount : 0,
    isExpanded: teamChats.isListExpanded,
    minVisibleCount: areRowsShown ? teamChats.collectiveChatIndex(chatId) + 1 : 0,
  };
}
